import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
//store
import store from "./store";
//Context
import { WalletProvider } from "util/wallet";
//component
import MyRouts from "./Routers/routes";

//Css
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "toastr/build/toastr.min.css";
import { isMobileDevice } from "helpers/constants";

function App() {
 console.log("ss")
  useEffect(()=>{
    //this code is for play to mint game.
   const isMobile = isMobileDevice();

    console.log("isMobile",isMobile);
    if(isMobile){
        localStorage.setItem("isPlayingInMobile",JSON.stringify({isPlayingInMobile : true}));
    }else{
      localStorage.setItem("isPlayingInMobile",JSON.stringify({isPlayingInMobile : false}));
    }
  },[])


  
  return (
    <div className="App">
      <Provider store={store}>
        <WalletProvider>
          <ToastContainer />
          <MyRouts />
        </WalletProvider>
      </Provider>
    </div>
  );
}

export default App;
